export default {
  en: {
    auth: {
      failed: 'These credentials do not match our records.',
      throttle: 'Too many login attempts. Please try again in {seconds} seconds.'
    },
    datetime: {
      shortDay: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
      ],
      dateSuffix: [
        'st',
        'nd',
        'rd',
        'th',
        'th',
        'th',
        'th',
        'th',
        'th',
        'th',
        'th',
        'th',
        'th',
        'th',
        'th',
        'th',
        'th',
        'th',
        'th',
        'th',
        'st',
        'nd',
        'rd',
        'th',
        'th',
        'th',
        'th',
        'th',
        'th',
        'th',
        'st'
      ],
      shortMonth: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
      ]
    },
    formatting: {
      percentage: '{number}%'
    },
    labels: {
      nav: {
        my_profile: 'My Profile',
        dashboard: 'Dashboard',
        todays_assignments: "Today's Assignments",
        customers: 'Customers',
        vehicles: 'Vehicles',
        tasks: 'Tasks',
        task_groups: 'Task Groups',
        settings: 'Settings',
        general: 'General',
        all_bookings: 'All Bookings'
      },
      create: 'Create',
      edit: 'Edit',
      destroy: 'Delete',
      delete: 'Delete',
      new: 'New',
      view: 'View',
      assume: 'Assume',
      clear: 'Clear',
      convert: 'Convert to',
      assign: 'Assign',
      text: 'Text',
      send: 'Send',
      download: 'Download',
      upload: 'Upload',
      yes: 'Yes',
      no: 'No',
      action_resource: '{action} {resource}',
      action_user: '{action} User',
      action_role: '{action} Role',
      action_customer: '{action} Customer',
      action_contact: '{action} Contact',
      action_property: '{action} Property',
      action_schedule: '{action} Schedule',
      action_booking: '{action} Booking',
      action_note: '{action} Note',
      action_document: '{action} Document',
      action_task: '{action} Task',
      action_task_group: '{action} Task Group',
      action_vehicle: '{action} Vehicle',
      resource_count: '{count} {resource}',
      discussion_with: 'Discussion with {contact}',
      destroy_comment: 'Delete Comment',
      property: 'Property | Properties',
      task: 'Task | Tasks',
      task_group: 'Task Group | Task Groups',
      text_message: 'Text Message | Text Messages',
      discussion: 'Discussion | Discussions',
      field_worker: 'Field Worker | Field Workers',
      list: 'List|Lists',
      manager: 'Manager|Managers',
      customer: 'Customer|Customers',
      user: 'User|Users',
      list_item: 'List Item|List Items',
      project: 'Project|Projects',
      project_worker: 'Worker|Workers',
      project_timer: 'Timer|Timers',
      my_project: 'My Project|My Projects',
      timer: 'Timer|Timers',
      role: 'Role',
      roles: 'Roles',
      contact: 'Contact',
      contacts: 'Contacts',
      properties: 'Properties',
      no_property: 'No Assigned Property',
      schedule: 'Schedule',
      schedules: 'Schedules',
      booking: 'Booking',
      report: 'Report',
      bookings: 'Bookings',
      note: 'Note',
      notes: 'Notes',
      document: 'Document',
      documents: 'Documents',
      title: 'Title',
      search: 'Search',
      image: 'Image',
      arrived: 'Arrived',
      start: 'Start',
      finish: 'Finish',
      left: 'Left',
      open: 'Open',
      discussions: 'Messages',
      calendar: 'Calendar',
      color: 'Colour',
      name: 'Name',
      email: 'Email',
      password: 'Password',
      phone: 'Phone Number',
      primary: 'Primary',
      profile_picture: 'Profile Picture',
      browse: 'Browse',
      choose_image: 'Choose Image',
      label: 'Label',
      boundary: 'Boundary',
      aprox_center: 'Approximate Center',
      lat: 'Lat: {lat}',
      lng: 'Lng: {lng}',
      file: 'File',
      size: 'Size',
      modified: 'Modified',
      description: 'Description',
      consumable: 'Consumable',
      choose_options: 'Choose some {resources}',
      choose_option: 'Choose a {resource}',
      chosen_options: '{count} {resources} selected',
      custom_booking: 'Custom Booking',
      due_at: 'Schedule Date',
      start_at: 'Start Date',
      end_at: 'End Date',
      end_time: 'End Time',
      quantity: 'Quantity',
      location: 'Location',
      registration: 'Registration',
      imei: 'IMEI',
      default_driver: 'Default Driver',
      driver: 'Driver',
      none: 'None',
      time: 'Time',
      latitude: 'Latitude',
      longitude: 'Longitude',
      altitude: 'Altitude',
      direction: 'Direction',
      speed: 'Speed',
      tracking: 'Tracking',
      vehicle_events: 'Events',
      state: 'State',
      parked: 'Parked',
      trip: 'Trip',
      from: 'From',
      to: 'To',
      address: 'Address',
      photos_notes: "Photo's & Notes",
      add_photo: 'Add Photo',
      drag_image: 'Drag Image onto Box',
      browse_image: 'Browse/Take Photo',
      drop_image: 'Drop Image(s) Here',
      primary_image: 'Primary',
      all_workers: 'All Field Workers',
      workers: 'Field Workers',
      pending: 'Pending',
      completed: 'Completed',
      repeat_booking: 'Repeat Booking',
      off: 'Off',
      monthly: 'Monthly',
      six_monthly: 'Six Monthly',
      annually: 'Annually',
      multi_day_booking: 'Multi Day Booking',
      manages_property: 'Manages Properties',
      managed_by: 'Managed By {name}',
      from_to: 'From - To',
      started: 'Started',
      ended: 'Ended',
      sign_in: 'Log In',
      sign_out: 'Log Out',
      submit: 'Submit',
      overview: 'Overview',
      update: 'Update',
      notify: {
        scheduled: 'Notify customer schedule confirmation',
        arrived: 'Notify customer when field worker arrives',
        left: 'Notify customer when field worker leaves'
      }
    },
    messages: {
      initial_load: "We're preparing a few things for you... In the meantime, enjoy the scenery",
      delete: 'Are you sure you want to delete this {resource}?',
      password_not_required: 'Only include a password here if you want to set or change it.',
      automatic_unit_ordering: 'If Automatic Unit Ordering is checked, the assigned units will be applied to this clients budget every month, until Automatic Unit Ordering is turned off. If any month has a one-off order amount placed in it, the recurring amount will not be applied.',
      rank: 'Fetch the ranking for this keyword according to your set schedule.',
      report: 'Include this keyword in the domains report.',
      promote: 'Identify which keywords are currently being targeted for this domain. These are the only ones users will see when fulfilling units.',
      multiple_keywords: 'Enter multiple keywords at once by separating them with a comma.',
      add_keyword: 'Add keyword to this clients target keywords.',
      unit_record_discussion_label: 'Discussion on {client} {type} record',
      discussion_toggle: 'Toggle the discussion window between floating and fixed.',
      discussion_close: 'Close and remove this discussion from your open discussion list.',
      type_comment: 'Type your comment here...',
      simple_loading: 'Loading {resource}',
      loading: 'Loading {count} {resource} from page {page}',
      loading_with_year: 'Loading {resource} from {year}',
      loading_with_month: 'Loading {resource} from {month}',
      report_subject: '{date} SEO Report for {client}',
      uploading_image: 'Uploading Image',
      uploading_files: 'Uploading Files',
      offline: "You're currently offline, you will only have access to some services in the app",
      last_updated: 'Last Updated: {time}',
      booking_repeats: 'This booking repeats {frequency}',
      convert_to_project: 'Are you sure you wish to convert this item to a project?'
    },
    notifications: {
      scheduled: 'Farmlink Rural has scheduled a visit to {property} on {date} at {time}.',
      service: '{user} will be attending the property for {task}',
      updated: 'Farmlink Rural has updated a scheduled visit, it is now scheduled as a visit to {property} on {date} at {time}.',
      cancelled: 'The scheduled visit on {date} to {property} has been cancelled.'
    },
    pagination: {
      previous: '&laquo; Previous',
      next: 'Next &raquo;'
    },
    passwords: {
      reset: 'Your password has been reset!',
      sent: 'We have emailed your password reset link!',
      throttled: 'Please wait before retrying.',
      token: 'This password reset token is invalid.',
      user: "We can't find a user with that email address."
    },
    permits: {
      settings: 'View/Edit Settings',
      edit_users: 'Add/Edit/Delete Users',
      roles: 'View Roles',
      edit_roles: 'Add/Edit/Delete Roles',
      edit_customers: 'Add/Edit/Delete Customers',
      edit_vehicles: 'Add/Edit/Delete Vehicles',
      customer_contacts: 'View Customer Contacts',
      edit_customer_contacts: 'Add/Edit/Delete Customer Contacts',
      customer_notes: 'View Customer Notes',
      edit_customer_notes: 'Add/Edit/Delete Customer Notes',
      customer_documents: 'View Customer Documents',
      edit_customer_documents: 'Add/Edit/Delete Customer Documents',
      customer_properties: 'View Customer Properties',
      edit_customer_properties: 'Add/Edit/Delete Customer Properties',
      customer_schedules: 'View Customer Schedules',
      edit_customer_schedules: 'Add/Edit/Delete Customer Schedules',
      edit_tasks: 'Add/Edit/Delete Tasks and Task Groups',
      edit_lists: 'Add/Edit/Delete Lists'
    },
    report: {
      text: {
        title: '{date} SEO Report'
      }
    },
    tips: {
      label: 'Provide a label that will help everyone identify this {resource}',
      description: 'The default description to be used.',
      consumable: 'If this is a consumable item, when completing any jobs with a consumable item the user will be asked to provide a quantity figure.',
      select_field_worker: 'Choose the assigned field worker for the {resource}',
      select_due_at: 'Set when this {resource} is due to be fulfilled',
      quantity: 'Enter the quantity of items consumed to fulfill this task',
      vehicle_description: 'E.g. Make, Model, Year',
      vehicle_registration: 'Vehicle registration plate number',
      default_driver: 'The default driver of this vehicle will automatically be assigned for each trip this vehicle takes'
    },
    validation: {
      accepted: 'The {attribute} must be accepted.',
      active_url: 'The {attribute} is not a valid URL.',
      after: 'The {attribute} must be a date after {date}.',
      after_or_equal: 'The {attribute} must be a date after or equal to {date}.',
      alpha: 'The {attribute} may only contain letters.',
      alpha_dash: 'The {attribute} may only contain letters, numbers, dashes and underscores.',
      alpha_num: 'The {attribute} may only contain letters and numbers.',
      array: 'The {attribute} must be an array.',
      before: 'The {attribute} must be a date before {date}.',
      before_or_equal: 'The {attribute} must be a date before or equal to {date}.',
      between: {
        numeric: 'The {attribute} must be between {min} and {max}.',
        file: 'The {attribute} must be between {min} and {max} kilobytes.',
        string: 'The {attribute} must be between {min} and {max} characters.',
        array: 'The {attribute} must have between {min} and {max} items.'
      },
      boolean: 'The {attribute} field must be true or false.',
      confirmed: 'The {attribute} confirmation does not match.',
      date: 'The {attribute} is not a valid date.',
      date_equals: 'The {attribute} must be a date equal to {date}.',
      date_format: 'The {attribute} does not match the format {format}.',
      different: 'The {attribute} and {other} must be different.',
      digits: 'The {attribute} must be {digits} digits.',
      digits_between: 'The {attribute} must be between {min} and {max} digits.',
      dimensions: 'The {attribute} has invalid image dimensions.',
      distinct: 'The {attribute} field has a duplicate value.',
      email: 'The {attribute} must be a valid email address.',
      ends_with: 'The {attribute} must end with one of the following: {values}.',
      exists: 'The selected {attribute} is invalid.',
      file: 'The {attribute} must be a file.',
      filled: 'The {attribute} field must have a value.',
      gt: {
        numeric: 'The {attribute} must be greater than {value}.',
        file: 'The {attribute} must be greater than {value} kilobytes.',
        string: 'The {attribute} must be greater than {value} characters.',
        array: 'The {attribute} must have more than {value} items.'
      },
      gte: {
        numeric: 'The {attribute} must be greater than or equal {value}.',
        file: 'The {attribute} must be greater than or equal {value} kilobytes.',
        string: 'The {attribute} must be greater than or equal {value} characters.',
        array: 'The {attribute} must have {value} items or more.'
      },
      image: 'The {attribute} must be an image.',
      in: 'The selected {attribute} is invalid.',
      in_array: 'The {attribute} field does not exist in {other}.',
      integer: 'The {attribute} must be an integer.',
      ip: 'The {attribute} must be a valid IP address.',
      ipv4: 'The {attribute} must be a valid IPv4 address.',
      ipv6: 'The {attribute} must be a valid IPv6 address.',
      json: 'The {attribute} must be a valid JSON string.',
      lt: {
        numeric: 'The {attribute} must be less than {value}.',
        file: 'The {attribute} must be less than {value} kilobytes.',
        string: 'The {attribute} must be less than {value} characters.',
        array: 'The {attribute} must have less than {value} items.'
      },
      lte: {
        numeric: 'The {attribute} must be less than or equal {value}.',
        file: 'The {attribute} must be less than or equal {value} kilobytes.',
        string: 'The {attribute} must be less than or equal {value} characters.',
        array: 'The {attribute} must not have more than {value} items.'
      },
      max: {
        numeric: 'The {attribute} may not be greater than {max}.',
        file: 'The {attribute} may not be greater than {max} kilobytes.',
        string: 'The {attribute} may not be greater than {max} characters.',
        array: 'The {attribute} may not have more than {max} items.'
      },
      mimes: 'The {attribute} must be a file of type: {values}.',
      mimetypes: 'The {attribute} must be a file of type: {values}.',
      min: {
        numeric: 'The {attribute} must be at least {min}.',
        file: 'The {attribute} must be at least {min} kilobytes.',
        string: 'The {attribute} must be at least {min} characters.',
        array: 'The {attribute} must have at least {min} items.'
      },
      not_in: 'The selected {attribute} is invalid.',
      not_regex: 'The {attribute} format is invalid.',
      numeric: 'The {attribute} must be a number.',
      password: 'The password is incorrect.',
      present: 'The {attribute} field must be present.',
      regex: 'The {attribute} format is invalid.',
      required: 'The {attribute} field is required.',
      required_if: 'The {attribute} field is required when {other} is {value}.',
      required_unless: 'The {attribute} field is required unless {other} is in {values}.',
      required_with: 'The {attribute} field is required when {values} is present.',
      required_with_all: 'The {attribute} field is required when {values} are present.',
      required_without: 'The {attribute} field is required when {values} is not present.',
      required_without_all: 'The {attribute} field is required when none of {values} are present.',
      same: 'The {attribute} and {other} must match.',
      size: {
        numeric: 'The {attribute} must be {size}.',
        file: 'The {attribute} must be {size} kilobytes.',
        string: 'The {attribute} must be {size} characters.',
        array: 'The {attribute} must contain {size} items.'
      },
      starts_with: 'The {attribute} must start with one of the following: {values}.',
      string: 'The {attribute} must be a string.',
      timezone: 'The {attribute} must be a valid zone.',
      unique: 'The {attribute} has already been taken.',
      uploaded: 'The {attribute} failed to upload.',
      url: 'The {attribute} format is invalid.',
      uuid: 'The {attribute} must be a valid UUID.',
      custom: {
        'attribute-name': {
          'rule-name': 'custom-message'
        }
      },
      attributes: []
    }
  }
}
